<template>
  <div id="client">
    <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
      <com-header />

      <div class="menu-content">
        <h1> 客户评价</h1>
        <div class="page-box-scroll">
          <div class="client-list">
            <div class="client-list-item" v-for="item in imgList">
              <el-image
                :src="item.img"
                :preview-src-list="getHandleImg(imgList)">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-backtop target=".page-box-scroll"></el-backtop>

  </div>
</template>

<script>
export default {
  name: "client",
  data(){
    return {
      navDrawer: false,
      imgList: [],
      navList: [],
      imgBg:''
    }
  },
  mounted() {
    this.getImgList()
    this.navList = JSON.parse(localStorage.getItem('navList'))
    this.getImgBg({id: this.$route.query.id })
  },
  methods: {
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getHandleImg(data) {
      if (data.length > 0) {
        let arr = data.map((item) => {
          return item = item.img
        })
        return arr
      }
      return []
    },
    getImgList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
      this.$get('/pc/shop/evaluate', {}).then((res) => {
        loading.close();
        this.imgList = [...this.imgList, ...res.data]
      }).catch((error) => {
        loading.close();
      })
    },

  }
}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/client.vue